<template>
  <layout-main-inner title="提现申请">
    <!-- <el-button slot="action"
      type="primary"
      @click="create"
      size="small">新增内容</el-button> -->
    <layout-card-wrap hasHeaderSlot>
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0">
        <el-form-item style="margin-bottom: 0">
          <el-radio-group
            v-model="config.status"
            @change="handleCurrentChange(1)">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="1">待审核</el-radio-button>
            <el-radio-button :label="2">审核通过</el-radio-button>
            <el-radio-button :label="9">审核未通过</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="合伙人名称"
          prop="agentName">
        </el-table-column>
        <el-table-column
          label="提现金额"
          prop="applyAmount"
          width="200"></el-table-column>
        <el-table-column
          label="提现月份"
          width="140">
          <template slot-scope="{row}">
            <div
              v-for="(item, index) in row.months"
              :key="index">{{ item | dateformat('YYYY年MM月') }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          width="140px">
          <template slot-scope="{row}">
            {{ row.applyTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.status === 1"
              type="info">待审核</el-tag>
            <el-tag
              v-if="row.status === 2"
              type="success">审核通过</el-tag>
            <el-tag
              v-if="row.status === 9"
              type="danger">审核未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="200">
          <template slot-scope="{row}">
            <el-dropdown v-if="row.status === 1">
              <el-button type="text">审核<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="auditPass(row)">通过</el-dropdown-item>
                <el-dropdown-item @click.native="auditFail(row)">不通过</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'WxappAgentWithdrawals',
  components: {},
  props: {},
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        status: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.config.vendorId = this.userInfo.vendorId
    this.fetchList()
  },
  methods: {
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('agent/getcommissioncleanings', {
        payload: {
          pageNum: this.config.pageNum,
          pageSize: this.config.pageSize,
          statusList: this.config.status === null ? null : [this.config.status]
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            i.months = JSON.parse(i.months).map(s => {
              return moment(s + '', 'YYYYMM')
            })
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    auditPass(row) {
      this.$confirm('此操作将通过提现审核, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('agent/ackcommissioncleaning', {
          payload: {
            agentCleaningId: row.agentCleaningId,
            vendorId: row.vendorId,
            pass: 1
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    auditFail(row) {
      this.$prompt('请输入审核不通过的原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '原因不能为空'
      }).then(({ value }) => {
        this.loading = true
        this.$store.dispatch('agent/ackcommissioncleaning', {
          payload: {
            agentCleaningId: row.agentCleaningId,
            vendorId: row.vendorId,
            pass: 0,
            reason: value
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  }
}
</script>
